<template>
  <div :class="parentClass" v-click-outside="hide">
    <el-button
      :title="title"
      :class="{ changeLangBtn: parentClass != 'relative' }"
      plain
      @click="show = !show"
    >
      <slot name="button"></slot>
    </el-button>

    <div
      v-if="show"
      class="
        absolute
        top-full
        w-full
        bg-white
        shadow-md
        flex flex-col
        items-start
        py-3
        px-4
        gap-2
        rounded-md
        border border-gray-300
        changeLangDropDown
      "
    >
      <slot @link-click="hide" name="content"></slot>
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'

export default {
  methods: {
    hide() {
      this.show = false
    },
  },
  props: ['title'],
  directives: {
    ClickOutside,
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    parentClass() {
      return this.$i18n.locale == 'fa' ? '' : ''
    },
  },
}
</script>
